import axios from "./api";
class ChallengeService {
  getAll() {
    return axios.get(`/challenges`);
  }
  get(id) {
    return axios.get(`/challenges/${id}`);
  }
  create(data) {
    return axios.post(`/challenges`, data);
  }
  update(id, data) {
    return axios.put(`/challenges/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/challenges/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ChallengeService();
